
import {createSlice} from "@reduxjs/toolkit";

export const contractDataPointSlice = createSlice({
    name: 'contractDataPointSlc',
    initialState: {value: {id: 0, contractSectionId: null, ordinalNumber: null, dataPointId: null,
            dataType: null, dataPointName: null,
            contractLevel: null, destinationFolder: null, versionInd: false, versionNumber: null,
            cycleInd: false, cycleNumber: null, calcGroup: null, calcWave: null,
            sourceContractSectionId: null, sourceContractDataPointId: null,
            status: null,
            mockIndicator: null, mockValue: null, mockOrigin: null, mockExpression: null, mockExpressionTranslation: null,
            cdpvCount: null, cdpvfCount: null, cdpvId: null, cdpvfId: null, cdpvCdpvfId: null,
            createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
            cdpDrawerState: false, cdpDrawerMode: null, cdpGridRefresh: false}},
    reducers:
{
    changeContractDataPoint: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDataPoint } = contractDataPointSlice.actions;

export default  contractDataPointSlice.reducer ;